import { initContract } from "@ts-rest/core";

//* We can't use alias here because it confuses FE
import contactRulesContract from "@src/resources/admin/contracts";
import analyticsContract from "@src/resources/analytics/contract";
//TODO: try to debug alias not working as intended
import campaignContract from "@src/resources/campaigns/contract";
import chatContract from "@src/resources/chat/contract";
import companiesContract from "@src/resources/companies/contract";
import contactsContract from "@src/resources/contacts/contract";
import ipSearchContract from "@src/resources/ipSearch/contract";
import organizationsContract from "@src/resources/organizations/contract";
import portfolioContract from "@src/resources/portfolio/contract";

const c = initContract();

const contract = c.router({
  analytics: analyticsContract,
  campaign: campaignContract,
  chat: chatContract,
  companies: companiesContract,
  contactRules: contactRulesContract,
  contacts: contactsContract,
  ipSearch: ipSearchContract,
  organizations: organizationsContract,
  portfolio: portfolioContract,
});

export default contract;
